<template>
  <div id="app">
    <router-view @sider="onCtrlSider"></router-view>
    <div class="re-sider" @click="show_popup = !0" v-if="sider_show">
        <van-icon name="fire" size="20"></van-icon>
        <span>热门</span>
    </div>
    <!-- 选择地址弹窗 -->
    <van-popup v-model="show_popup" class="sider_popup" position="left" :style="{width: '35%', height: '100%'}">
        <div class="title">
            <van-icon name="fire" size="22" color="red"></van-icon>
            <span>热门推荐</span>
        </div>
        <div class="category">
            <van-grid :column-num="1" :border="false">
                <van-grid-item v-for="(val, index) in grids" :key="index" :icon="val.img" :text="val.name" :to="val.to" :url="val.url" :badge="val.badge"/>
            </van-grid>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { Icon, Popup, Grid, GridItem } from 'vant';

export default {
    name: 'App',
    components: {
        [Icon.name]: Icon,
        [Popup.name]: Popup,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
    },
    data() {
        return {
            sider_show: !1,
            show_popup: !1,
            grids: [
                {
                    'img': require('assets/images/hoods.png'),
                    'name': '油烟机清洗',
                    // 'to': { path: '/cate', query:{id: 5}}
                    'url': '/cate?id=5',
                },
                {
                    'img': require('assets/images/pack.png'),
                    'name': '清洗大礼包',
                    // 'to': { path: '/cate', query:{id: 10}},
                    'url': '/cate?id=10',
                    'badge': 'new',
                },
                {
                    'img': require('assets/images/group.png'),
                    'name': '我要拼团',
                    'url': '/group',
                    'badge': 'new',
                },
                {
                    'img': require('assets/images/bargain.png'),
                    'name': '我要砍价',
                    'url': '/bargain',
                    'badge': 'new',
                },
            ],
        };
    },
    created: function () {
    },
    methods: {
        onCtrlSider(flag) {
            this.sider_show = flag
        }
    }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
p {
  margin-block-start: 0;
  margin-block-end: 0;
}

.van-coupon__amount {
  margin-block-start: 0;
  margin-block-end: 0;
}

.re-sider {
  position: fixed;
  left: 0;
  top: 300px;
  height: 60px;
  padding: 0 30px 0 10px;
  color: #fff;
  background: rgba(0,0,0,.5);
  display: flex;
  line-height: 60px;
  border-radius: 0 30px 30px 0;
}
.re-sider .van-icon {
    margin-top: 9px;
    margin-right: 5px;
}

.sider_popup .title {
    margin: 30px 0 10px;
    display: flex;
    justify-content: center;
    height: 60px;
    line-height: 60px;
}

.sider_popup .title .van-icon{
    margin-top: 5px;
    margin-right: 5px;
}

.category .van-grid-item__content {
    padding-bottom: 15px;
    padding-top: 15px;
}
.category .van-grid-item__icon {
    font-size: 115px;
    height: 115px;
}

.category .van-grid-item__text {
    font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue